import { FlatTreeControl, FlatTreeControlOptions } from '@angular/cdk/tree';
import { firstValueFrom, ReplaySubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SharepointObjectEntity } from '../../../../dave-data-module/entities/sharepoint-object.entity';
import { DynamicFolderTreeFlatNode } from '../../../dynamic-folder-tree-data.service';
import { dmsFolderTreeControl } from '../folder-tree-control';
import { SharepointDataService } from './sharepoint-data.service';

export class SharepointFolderTreeControl<K = DynamicFolderTreeFlatNode<string>> extends FlatTreeControl<DynamicFolderTreeFlatNode<string>, K> implements dmsFolderTreeControl<string> {
    expanded = new ReplaySubject<DynamicFolderTreeFlatNode<string>>(1);

    constructor(
        private dataService: SharepointDataService,
        getLevel: (dataNode: DynamicFolderTreeFlatNode<string>) => number,
        isExpandable: (dataNode: DynamicFolderTreeFlatNode<string>) => boolean,
        options?: FlatTreeControlOptions<DynamicFolderTreeFlatNode<string>, K> | undefined,
    ) {
        super(getLevel, isExpandable, options);
    }

    async expandFolder(id: string) {
        if (!this.dataNodes) {
            console.warn('dataNodes is undefined');
            return;
        }
        const lastExpanded = await firstValueFrom(this.expanded);
        if (lastExpanded?.item.entityId === id) {
            return;
        }
        this.collapseAll();

        let folders = await firstValueFrom(this.dataService.getFolderAndParentsById(id));
        const foldersSorted = sortByParent(folders);
        const folderIdsSorted = foldersSorted.map((f) => f.Id);
        for (const folderId of folderIdsSorted) {
            const node = this.dataNodes.find((d) => d.item.entityId === folderId && d.item.isFolder === true);
            if (node) {
                this.expand(node);
                await firstValueFrom(this.expanded.pipe(filter((expandedNode) => expandedNode.item.entityId === node.item.entityId && expandedNode.item.isFolder === true)));
            }
        }
    }
}
function sortByParent(array: SharepointObjectEntity[], rootId?: string) {
    return array.slice().reverse(); // todo, ggf sortierlogik einbauen, momentan nicht machbar da vom be keine parentid oä zurück kommt
    // const root = array.find((a) => a.ParentId);
    // const ret: SharepointGetObjectEntity[] = [root];
    // while (true) {
    //     const child = array.find((a) => ret[ret.length - 1].Id === a.ParentId);
    //     if (child) {
    //         ret.push(child);
    //     }
    //     if (!child || ret.length === array.length) {
    //         break;
    //     }
    // }
    // return ret;
}
